import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Row, Col } from 'react-bootstrap';

const BankMasterModal = ({ show, handleClose, mode, bankData, onSave }) => {
  const [formData, setFormData] = useState({
    bankName: '',
    keyword: '',
    ifsc: '',
    maxlength: '',
    minlength: '',
    verifyStatus: 'Pending',
    mode: 'NEFT',
    creditCard: 'No'
  });

  useEffect(() => {
    if (mode === 'edit' && bankData) {
      setFormData(bankData);
    } else {
      setFormData({
        bankName: '',
        keyword: '',
        ifsc: '',
        maxlength: '',
        minlength: '',
        verifyStatus: 'Pending',
        mode: 'NEFT',
        creditCard: 'No'
      });
    }
  }, [mode, bankData, show]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    handleClose();
  };

  return (
    <Modal show={show} onHide={handleClose} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {mode === 'add' ? 'Add Bank' : 'Edit Bank'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Bank Name <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="bankName"
                  value={formData.bankName}
                  onChange={handleChange}
                  placeholder="Enter bank name"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Keyword <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="keyword"
                  value={formData.keyword}
                  onChange={handleChange}
                  placeholder="e.g., HDFC, ICICI"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>IFS Code <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="text"
                  name="ifsc"
                  value={formData.ifsc}
                  onChange={handleChange}
                  placeholder="e.g., HDFC0001234"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Min Length <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="number"
                  name="minlength"
                  value={formData.minlength}
                  onChange={handleChange}
                  placeholder="9"
                  required
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group className="mb-3">
                <Form.Label>Max Length <span className="text-danger">*</span></Form.Label>
                <Form.Control
                  type="number"
                  name="maxlength"
                  value={formData.maxlength}
                  onChange={handleChange}
                  placeholder="16"
                  required
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Verify Status</Form.Label>
                <Form.Select
                  name="verifyStatus"
                  value={formData.verifyStatus}
                  onChange={handleChange}
                >
                  <option value="Verified">Verified</option>
                  <option value="Pending">Pending</option>
                  <option value="Not Verified">Not Verified</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Mode</Form.Label>
                <Form.Select
                  name="mode"
                  value={formData.mode}
                  onChange={handleChange}
                >
                  <option value="NEFT">NEFT</option>
                  <option value="RTGS">RTGS</option>
                  <option value="IMPS">IMPS</option>
                  <option value="UPI">UPI</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={4}>
              <Form.Group className="mb-3">
                <Form.Label>Credit Card</Form.Label>
                <Form.Select
                  name="creditCard"
                  value={formData.creditCard}
                  onChange={handleChange}
                >
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button 
              variant="secondary" 
              onClick={handleClose}
              className="btn-outline-danger-custom"
            >
              Cancel
            </Button>
            <Button 
              type="submit"
              className="btn-outline-primary-custom"
            >
              {mode === 'add' ? 'Add Bank' : 'Update Bank'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default BankMasterModal;

